import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { apiBaseUrl } from "network";

export const catApi = createApi({
    reducerPath: "catApi",
    baseQuery: fetchBaseQuery({
        baseUrl: apiBaseUrl,
        prepareHeaders: (headers, { getState }) => {
            const token = getState().auth.token;
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        updateNav: builder.mutation({
            query: (body) => ({ url: "admin-category/makeNav", method: "POST", body: body }),
        }),
        addCat: builder.mutation({
            query: (body) => ({ url: "admin-category/add", method: "POST", body: body }),
        }),
        updateCat: builder.mutation({
            query: ({id,data}) => ({ url: `admin-category/cat/${id}`, method: "PUT", body: data }),
        }),
        getAllCatList: builder.query({
            query: ({ page, limit, search }) => ({
                url: `admin-category/list?page=${page}&limit=${limit}&search=${search}`
            }),
            transformResponse: (response) => response.data
        }),
        getSubCatByCatId: builder.mutation({
            query: (catId) => ({ url: `admin-category/subcat/${catId}`, method: "GET"}),
        }),
        getAllSubCatList: builder.query({
            query: ({ page, limit, search }) => ({
                url: `admin-category/sublist?page=${page}&limit=${limit}&search=${search}`
            }),
            transformResponse: (response) => response.data
        }),
        addSubCat: builder.mutation({
            query: (body) => ({ url: "admin-category/addSub", method: "POST", body: body }),
        }),
        updateSubCat: builder.mutation({
            query: ({id,data}) => ({ url: `admin-category/editsub/${id}`, method: "PUT", body: data }),
        }),
        
    })
})

export const { useAddCatMutation,useGetAllCatListQuery,useUpdateNavMutation,useUpdateCatMutation,useGetAllSubCatListQuery,useAddSubCatMutation,useUpdateSubCatMutation,useGetSubCatByCatIdMutation } = catApi;
